import React, { Fragment } from 'react';
import { FaFacebook, FaInstagram, FaGithub, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { SideLeft, SideRight } from '../styles';

const SideContact = () => {
    return (
        <Fragment>
            <SideLeft>
                <ul>
                   <li><a rel="noopener noreferrer" href="https://github.com/ezelujan" target="_blank"><FaGithub /></a></li>
                   <li><a rel="noopener noreferrer" href="https://www.linkedin.com/in/ezedev/" target="_blank"><FaLinkedinIn /></a></li>
                   <li><a rel="noopener noreferrer" href="https://www.facebook.com/ezelujan147/" target="_blank"><FaFacebook /></a></li> 
                   <li><a rel="noopener noreferrer" href="https://www.instagram.com/ezequiel_147/" target="_blank"><FaInstagram /></a></li> 
                   <li><a rel="noopener noreferrer" href="https://twitter.com/EzequielLujnEs1" target="_blank"><FaTwitter /></a></li> 
                </ul>
            </SideLeft>
            <SideRight>
                <div>
                    <a rel="noopener noreferrer" href="mailto:ojos1098@gmail.com">ojos1098@gmail.com</a>
                </div>
            </SideRight>
        </Fragment>
    );
}

export default SideContact;